import { render, staticRenderFns } from "./HeroDiscover.vue?vue&type=template&id=6e12cdf6&scoped=true&"
import script from "./HeroDiscover.vue?vue&type=script&lang=js&"
export * from "./HeroDiscover.vue?vue&type=script&lang=js&"
import style0 from "./HeroDiscover.vue?vue&type=style&index=0&id=6e12cdf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e12cdf6",
  null
  
)

export default component.exports